import { useTranslation } from "@opendash/i18n";
import { Button, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import MetaFieldCreation from "./MetaFieldCreation";

type Props = {};

export const StepMetaButton = observer((props: Props) => {
  const t = useTranslation();
  const ref = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  function handleModalConfirm() {
    ref.current?.click();
  }

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        {t("maintenance:schedule.step.meta.create.label")}
      </Button>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleModalConfirm}
        okText={t("maintenance:global.button.save_label")}
        title={t("maintenance:schedule.step.meta.create.label")}
        destroyOnHidden
      >
        <MetaFieldCreation
          btnRef={ref}
          styles={{ submit: { display: "none" } }}
          afterSave={() => setOpen(false)}
        />
      </Modal>
    </>
  );
});
